import { createSlice } from '@reduxjs/toolkit';

const sampleNotifications = [
  {
    notification_id: 1,
    notification_heading: 'Notification one',
    description: 'Notification one has some great content',
    is_read: false,
    notification_time: Date.now(),
  },
  {
    notification_id: 2,
    notification_heading: 'Notification two',
    description: 'Notification two has some great content',
    is_read: true,
    notification_time: Date.now(),
  },
];

const initialState = {
  from: '',
  template: null,
  anchorEl: null,
  optionsList: [],
  optionsObject: {},
  foodAllergyList: [],
  environmentalAllergyList: [],
  medicationAllergyList: [],
  biologicAllergyList: [],
  // notificationsList: [...sampleNotifications],
  notificationsList: [],
};

const popoverSlice = createSlice({
  name: 'popoverSlice',
  initialState,
  reducers: {
    setAnchorEl: (state, action) => {
      state.anchorEl = action?.payload;
    },

    setTemplate: (state, action) => {
      state.template = action?.payload;
    },

    setPopoverFrom: (state, action) => {
      state.from = action?.payload;
    },

    pushNotification: (state, action) => {
      state.notificationsList = [action.payload, ...state.notificationsList];
    },

    setNotificationsList: (state, action) => {
      const { title, descriptions } = action?.payload;
      state.notificationsList = [
        ...state.notificationsList,
        { title, descriptions },
      ];
    },

    setPopoverOptionsList: (state, action) => {
      state.optionsList = [...action?.payload];
    },

    clearNotificationsList: (state, action) => {
      state.notificationsList =  [];
    },

    clearNotificationById : (state , action) =>{
      state.notificationsList = action?.payload
        && state.notificationsList.filter(
            n => n.notification_id !== action.payload
          )
    },

    setPopoverOptionsObject: (state, action) => {
      const { type, optionsList, optionsListName } = action?.payload;
      state.optionsObject = {
        ...state?.optionsObject,
        [type]: {
          ...state?.optionsObject?.[type],
          [optionsListName]: optionsList,
        },
      };
    },

    setPopoverAllergyList: (state, action) => {
      const { type, list } = action?.payload;

      if (type === 'FOOD') {
        state.foodAllergyList = list;
      }

      if (type === 'ENVIRONMENTAL') {
        state.environmentalAllergyList = list;
      }

      if (type === 'MEDICATION') {
        state.medicationAllergyList = list;
      }

      if (type === 'BIOLOGIC') {
        state.biologicAllergyList = list;
      }
    },

    setResetPopoverAllergyList: (state, action) => {
      state.foodAllergyList = [];
      state.environmentalAllergyList = [];
      state.medicationAllergyList = [];
      state.biologicAllergyList = [];
    },
  },
});

export const {
  setAnchorEl,
  setPopoverOptionsList,
  setPopoverOptionsObject,
  setPopoverAllergyList,
  setTemplate,
  
  setPopoverFrom,
  setNotificationsList,
  clearNotificationsList,
  clearNotificationById,
  setResetPopoverAllergyList,
  pushNotification,
} = popoverSlice.actions;
export default popoverSlice.reducer;
